import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { message } from "antd";
import { queryClient } from "../../services/queryClient";
import { getToken } from "../../utils/getToken";

export const useSuspendAdminMutation = (id: string) => {
  const token = getToken();
  return useMutation({
    mutationFn: (payload: {
      firstName: string;
      lastName: string;
      role: string;
    }) =>
      axiosInstance
        .post(`/admins/${id}/suspend`, payload, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res: any) => res.data),
    onSuccess: async (data: any) => {
      message.success(data?.message);
      queryClient.invalidateQueries({ queryKey: ["useGetAdminsQuery"] });
    },
    onError: (error: any) => {
      message.error(error?.response?.data?.message);
    },
  });
};
